import React, {Component} from 'react';
import {Col, Rate,Tooltip} from 'antd';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {reverseParseTextView} from './createRender';
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';

const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
        // 获取所有的图片
        let data = reverseParseTextView(this.props.data);
        this.props.getData && this.props.getData(data);
    }

    componentDidUpdate(preProps) {
        // 获取所有的图片
        if (preProps.data.question_id !== this.props.data.question_id) {
            let data = reverseParseTextView(this.props.data);
            this.props.getData && this.props.getData(data);
        }
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }

    mapTag = str => {
        let stem  = str;
        let regStem = /\(!([āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑńňɡａ-ｚＡ－ＺA-Za-z\\s∥-]+)!\)/ig;
        let regAllText = /([\u4e00-\u9fa5]\(![āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑńňɡａ-ｚＡ－ＺA-Za-z\\s∥-]+!\))/ig;
        stem = stem.replace(regAllText, `<ruby>$1</ruby>`);
        stem = stem.replace(regStem, `<rp>(</rp><rt>$1</rt><rp>)</rp>`);
        return stem;
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    render() {
        const {visible} = this.state;

        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        const {num, index} = this.props;
        // let data = reverseParseTextView(originData);//图片显示不正常
        let data = reverseParseTextView(JSON.parse(JSON.stringify(originData)));//图片显示不正常
        let stem = data.stem || '';
        if (stem) {
            //console.log(stem)
            stem = this.mapTag(stem);
        }

        if(!data){
            return (
                <div className="box-exercise" ref={'viewer'}>
                    <div className="exercise-content">
                        <div><h3 style={{color:'red',textAlign:'center'}}>此题解析有误</h3></div>
                        {num!=='undefined'&&<div className="exercise-num"><p className="math_text" style={{margin: 0, lineHeight: '27px'}}>{index || index === 0 ? `${index+1} - ${num+1}`  : `${num+1}、`}</p></div>}
                        <div className="exercise-con"  />
                        <div  style={{border:'1px solid red'}} >
                            {originData.stem}
                        </div>
                    </div>
                    <div className="exercise-footer">
                        {
                            visible &&
                            <div className="footer-hide relative">
                                <div>
                                    {originData.answer}
                                </div>
                                {
                                    data.explain && <div>
                                        <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                        <div className="inline-block">
                                            <span style={{fontSize: 14}}  dangerouslySetInnerHTML={this.createHtml(originData.explain)}/>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div className="footer-show relative">
                            <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                                {
                                    this.props.canShowAnswer ?
                                        <button
                                            className="question-btn"
                                            onClick={(e) => this.toggleAnswer(!visible,e)}>
                                            {!visible ? '显示答案' : '隐藏答案'}
                                        </button> : null
                                }

                            </Footer>
                        </div>
                    </div>
                </div>
            )

        }
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text" style={{margin: 0, lineHeight: '27px'}}>{index || index === 0 ? `${index+1} - ${num+1}`  : `${num+1}、`}</p></div>}
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(stem)}/>
                    {
                        <div id={'FENLEI'} style={{overflow: 'hidden', position: 'relative'}} className={'questionCore'}>
                            {
                                data.item_list && !!data.item_list.length &&
                                <div className="exercise-options">
                                    <p style={{fontSize: 14, color: '#c3cad0', marginBottom: 10}}>选项：</p>
                                    {
                                        data.item_list.map((val, key) =>
                                            <span key={key} className="category-option"
                                                  dangerouslySetInnerHTML={this.createHtml(this.mapTag(val.item))}/>
                                        )
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div style={{display: 'inline-block', verticalAlign: 'top', fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</div>
                                <div style={{display: 'inline-block', verticalAlign: 'top', width: '80%'}}>
                                    {
                                        data.answer.map((val, index) =>
                                            <div key={index}>
                                                <p style={{marginRight: 10, fontSize: 14, verticalAlign: 'top'}}><span dangerouslySetInnerHTML={this.createHtml(this.mapTag(data.stemMap[val.drop_id]))}></span>:</p>
                                                {
                                                    val.result.map((item, i) => 
                                                        <span key={i} className="category-option" style={{fontSize: 14}} 
                                                            dangerouslySetInnerHTML={this.createHtml(this.mapTag(data.itemsMap[item]))} />
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/classify/viewForView.js